import { pipe } from 'rxjs';
import { map } from 'rxjs/operators';

import type { VisualizationMapperOperatorInput, VisualizeOperatorInput } from '@core/reports-types';

import { createDataset } from './dataset';

export const normalize = ({
  component,
  data,
  metric,
  meta,
}: VisualizeOperatorInput): VisualizationMapperOperatorInput => {
  const dataset = createDataset(data, metric);

  return { component, dataset, metric, meta };
};

export const normalizePipe = pipe(map(normalize));
